module.exports = {"EQUIPMENT_NAME":"Name"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/equipment/equipment.en.json
// module id = WAFz
// module chunks = 0